export const DEFAULT_ROWS_LIMIT = 100;